// @ts-check

/**
 * @enum {number}
 * @private
 */
const ModelAnimationState = {
  STOPPED: 0,
  ANIMATING: 1,
};

Object.freeze(ModelAnimationState);

export default ModelAnimationState;
